/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');
import Vue from 'vue'
import i18n from './i18n';
// window.Vue = require('vue').default;
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'

// window.router=router;
// window.Fire = new Vue();
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.component('date-picker', VuePersianDatetimePicker);

import Toasted from 'vue-toasted';
import './plugins'
import './assets/main.css';
import App from './App.vue'
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.config.productionTip = false
Vue.use(Toasted,{duration:3000,position:'top-center',iconPack : 'mdi',icon:{name:'check',after:true}});

sync(store, router)
new Vue({
    i18n,
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app');

